import type { ValidationResult } from 'joi';
import { cloneDeep } from 'lodash';

import { SerializableObjectSchema } from '../../../../../objects/generic/serialization/serializable-object-schema';
import { PossibleAdminRole } from '../../../../../objects/user/admin-roles/types';
import { PossibleRole } from '../../../../../objects/user/roles/types';
import { CommunicationsRequestName } from '../../../communications-request-name';
import { CommunicationsRequest } from '../../generic/communications-request/communications-request';
import { CommunicationsRequestSchema } from '../../generic/communications-request/communications-request-schema';

import { CommunicationsRequestGetSessionIdConstructor } from './communications-request-get-session-id-constructor';
import { CommunicationsRequestGetSessionIdSchema } from './communications-request-get-session-id-schema';

export class CommunicationsRequestGetSessionId extends CommunicationsRequest {
  protected callSid!: string;

  constructor(parameters: CommunicationsRequestGetSessionIdConstructor) {
    super({
      ...parameters,
      [CommunicationsRequestSchema.type]: CommunicationsRequestName.getSessionId,
    });
  }

  protected static _deserialize(validationResult: ValidationResult): CommunicationsRequestGetSessionId {
    return new CommunicationsRequestGetSessionId(super._deserialize(validationResult));
  }

  public serialize() {
    return super.serialize(CommunicationsRequestGetSessionId.getSchema());
  }

  public static getSchema(): SerializableObjectSchema {
    return new CommunicationsRequestGetSessionIdSchema();
  }

  public getRequiredRoles(): PossibleRole[] {
    return [];
  }

  public getRequiredAdminRoles(): PossibleAdminRole[] | undefined {
    return undefined;
  }

  public getCallSid(): string {
    return cloneDeep(this.callSid);
  }
}
